import { render } from "./searchFoodModel.vue?vue&type=template&id=3ceb2520"
import script from "./searchFoodModel.vue?vue&type=script&lang=js"
export * from "./searchFoodModel.vue?vue&type=script&lang=js"

import "./searchFoodModel.vue?vue&type=style&index=0&id=3ceb2520&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__